/* eslint-disable react/jsx-no-useless-fragment */

import * as React from "react";
import { Col, FormGroup, Row } from "react-bootstrap";

import { strategyTargetGroupLabels } from "../../../../../../../label/activity";

import { Checkboxes, Option } from "../../../../../../../react-components/lu-component/src/index";
import { AccordionForm } from "../../../../parts/accodion-form";
import { StrategyGroup } from "../../../../../../../server/models/activity";
import { otherConcernsOptions } from "../../../../../../../server/models/activity/strategy-group";

type Props = {
	onChange: (name: keyof StrategyGroup, value: any) => void;
	strategyGroup: StrategyGroup;
};

export const OtherConcernsCheckboxes = React.memo((props: Props) => {
	const { onChange, strategyGroup } = props;

	return (
		<Row>
			<FormGroup as={Col} md={5}>
				<AccordionForm
					defaultShow={strategyGroup.otherConcerns != null && 0 < strategyGroup.otherConcerns.length}
					eventKey="otherConcerns"
					title={strategyTargetGroupLabels.otherConcerns ?? ""}
				>
					<Checkboxes
						checkeds={strategyGroup.otherConcerns ?? []}
						choices={otherConcernsOptions as Option[]}
						name="otherConcerns"
						onChange={(value) => {
							onChange("otherConcerns", value);
						}}
					/>
				</AccordionForm>
			</FormGroup>
		</Row>
	);
});
